import React from 'react'
import { App } from './views'
import { routesConfig } from './routesConfig'
import { AppIcon } from './components'
import { displayName, appName } from './appConfig'
import { getCalendarEvents } from './helpers/calendarEvents'

export const appDefinition = {
  displayName,
  name:      appName,
  category:  'processes',
  Component: () => <App appName={appName} />,
  AppIcon,
  routes:    routesConfig(appName, displayName),
  // Booked interviews also show up in the intranet landing page's ActivityWidget, which
  // aggregates any app exposing these two fields (spa/src/hooks/useActivity.js).
  calendarColor:  'var(--color-purple)',
  calendarEvents: getCalendarEvents,
}
